const Smile = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.8706 5.95634C5.38561 5.95634 5.80311 5.53884 5.80311 5.02382C5.80311 4.50881 5.38561 4.09131 4.8706 4.09131C4.35558 4.09131 3.93808 4.50881 3.93808 5.02382C3.93808 5.53884 4.35558 5.95634 4.8706 5.95634Z" />
      <path d="M10.062 5.02382C10.062 5.53884 9.64453 5.95634 9.12951 5.95634C8.6145 5.95634 8.197 5.53884 8.197 5.02382C8.197 4.50881 8.6145 4.09131 9.12951 4.09131C9.64453 4.09131 10.062 4.50881 10.062 5.02382Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00007 6.7633C5.88662 6.7633 4.84276 7.32003 4.23036 8.25254C3.93808 8.69792 3.91025 9.28248 4.16077 9.7557C4.4113 10.2289 4.89844 10.5212 5.44124 10.5212H8.57282C9.11563 10.5212 9.58884 10.2289 9.85329 9.7557C10.1038 9.28248 10.076 8.71184 9.7837 8.25254C9.15738 7.32003 8.11352 6.7633 7.00007 6.7633ZM9.0878 9.35186C8.97645 9.54672 8.7816 9.67198 8.55891 9.67198H5.44125C5.21856 9.67198 5.0237 9.56064 4.91236 9.35186C4.80101 9.15701 4.81493 8.9204 4.94019 8.72555C5.39949 8.02964 6.16499 7.6121 7.00008 7.6121C7.83516 7.6121 8.60066 8.02964 9.05996 8.72555C9.18522 8.9204 9.19914 9.14309 9.0878 9.35186Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00003 0.388916C3.35348 0.388916 0.388916 3.35348 0.388916 7.00003C0.388916 10.6466 3.35348 13.6111 7.00003 13.6111C10.6466 13.6111 13.6111 10.6466 13.6111 7.00003C13.6111 3.35348 10.6466 0.388916 7.00003 0.388916ZM6.99999 12.5949C3.92408 12.5949 1.4049 10.0896 1.4049 6.99977C1.4049 3.92387 3.91016 1.40469 6.99999 1.40469C10.0898 1.40469 12.5951 3.90995 12.5951 6.99977C12.5951 10.0757 10.0759 12.5949 6.99999 12.5949Z"
      />
    </svg>
  );
};

export default Smile;
